import React from "react";
import classnames from "classnames";
import { Watch } from "scrollmonitor-react";
import styles from "./Iframe.styl";

/* eslint import/no-webpack-loader-syntax: off */

class Iframe extends React.PureComponent {
  constructor(props) {
    super(props);
    window.addEventListener("message", this.resizeIframe, false);
  }

  scrollTop = () => {
    window.scrollTo(0, 0);
  };

  resizeIframe = event => {
    const iframe_id = "ifaw-iframe";

    if (event.data.hasOwnProperty("frameHeight")) {
      document.getElementById(
        iframe_id
      ).style.height = `${event.data.frameHeight}px`;
    } else if (event.data.hasOwnProperty("scroll") && event.data.scroll) {
      // Only scrolls if that message is not coming from a donation page
      // e.data.scroll will be 1 if it's coming from a donation page
      document.getElementById(iframe_id).scrollIntoView({
        behavior: "smooth"
      });
      console.log("Scrolling to Iframe");
    }
  };

  render() {
    this.props.lockWatcher();
    return (
      <div className={classnames(styles.innerWrapper)}>
        <div
          className={classnames(styles.gradientBG)}
          onClick={this.scrollTop}
        />
        <form style={{ position: "relative" }}>
          <div className="">
            <iframe
              title="Loading..."
              id="ifaw-iframe"
              width="100%"
              scrolling="no"
              className={styles.ifawIframe}
              src={this.props.src}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </form>
        <div className={styles.gradientUnderline} />
      </div>
    );
  }
}

export default Watch(Iframe);



// WEBPACK FOOTER //
// ./src/components/4site/Iframe.js